module.exports = __webpack_public_path__ + "img/album18_10.f554bb5d.jpg";